<template>
  <div class="prod-compare" qaid="productCompareContainer">
    <div class="section-header section-header--lg flex" qaid="productCompareHeaderContainer">
      <p class="heading" qaid="productCompareHeader">{{ bp('compareTitle') }}</p>
      <trek-link button text small :href="lastPlpUrl" icon="add_circle_outline" qaid="productCompareHeaderAddProduct">
        <span v-html="bp('addProduct')"></span>
      </trek-link>
    </div>
    <collapse
      v-if="!loading"
      v-cloak
      icon-active="expand_more"
      icon-inactive="expand_less"
      icon-position="left"
      :default-active="false"
      :value="activeTabs"
    >
      <div class="side-scroll-wrapper" qaid="productCompareSectionsWrapper">
        <div class="side-scroll-wrapper--inner" :class="[bikeNumClass]">
          <template v-for="(section, key) in compareSections">
            <collapse-item v-if="showSection(key, section)" :key="key" :name="key">
              <div slot="title" class="heading heading--sm" :qaid="`productCompareTitle-${section.label}`">
                {{ section.label }}
              </div>
              <component
                :is="whichSection(key)"
                :reviews-rendered="reviewsRendered"
                :base-properties="baseProperties"
                :meta-data="metaData"
                :section-data="section"
                :section-key="key"
                @reviews-rendered="reviewsRendered = true"
              ></component>
            </collapse-item>
          </template>
          <compare-overview
            :reviews-rendered="reviewsRendered"
            :base-properties="baseProperties"
            :meta="true"
            :meta-data="metaData"
            :section-data="compareSections.overview"
            section-key="overview"
            @reviews-rendered="reviewsRendered = true"
          ></compare-overview>
        </div>
      </div>
    </collapse>
    <trek-link
      button
      secondary
      icon="arrow_back"
      :href="lastPlpUrl"
      class="mt-5 mb-2"
      qaid="productCompareContinueShoppingButton"
    >
      <span v-html="bp('continueShopping')"></span>
    </trek-link>
    <div>
      <trek-button text icon="delete" qaid="productCompareDeleteRackButton" @click="deleteRack">
        <span v-html="bp('deleteRack')"></span>
      </trek-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapActions, mapState, mapGetters} from 'vuex';
import Collapse from '@/components/Collapse';
import CollapseItem from '@/components/CollapseItem';
import CompareOverview from '@/components/compare/CompareOverview';
import CompareTechSpecs from '@/components/compare/CompareTechSpecs';
import CompareWhyWeLoveIt from '@/components/compare/CompareWhyWeLoveIt';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  name: 'CompareContainer',

  components: {
    CollapseItem,
    Collapse,
    CompareOverview,
    CompareTechSpecs,
    CompareWhyWeLoveIt,
    TrekButton,
    TrekLink,
  },

  data() {
    return {
      loading: true,
      activeTabs: ['overview', 'techSpecs'],
      compareSections: {},
      metaData: {},
      productList: [],
      reviewsRendered: false,
    };
  },

  computed: {
    bikeNumClass() {
      return this.currentProducts ? `products${this.currentProducts.length}` : null;
    },

    compareUrl() {
      if (!this.currentRack) return '';
      return `/compareJson/?productList=${this.currentProducts.join(',')}`;
    },

    currentProducts() {
      return this.currentRack.reduce((acc, {productCode}) => {
        return acc.concat(productCode);
      }, []);
    },

    lastPlpUrl() {
      return this.lastPlp ? this.lastPlp : this.encodedContextPath;
    },

    productSkus() {
      return Object.keys(this.metaData);
    },

    ...mapState('backend', ['encodedContextPath']),
    ...mapState('storage', ['lastPlp']),
    ...mapGetters('compare', ['currentRack']),
  },

  watch: {
    currentProducts() {
      if (this.currentProducts.length) {
        this.fetchData();
      } else {
        window.location = this.lastPlpUrl;
      }
    },
  },

  mounted() {
    if (this.currentProducts.length) {
      this.fetchData();
    }
  },

  methods: {
    showSection(key, section) {
      switch (key) {
        case 'overview':
          return section.compareItems && section.compareItems.length;
        case 'techSpecs':
          if (
            section &&
            section.specGroups &&
            section.specGroups.length === 1 &&
            section.specGroups[0].compareItems &&
            section.specGroups[0].compareItems.length === 0
          ) {
            return false;
          }
          return section.specGroups && section.specGroups.length;
        case 'why_we_love_it':
          return section.compareItems && section.compareItems.length;
        default:
          return true;
      }
    },

    deleteRack() {
      this.emptyRack().then(() => (window.location = this.lastPlpUrl));
    },

    fetchData() {
      if (this.compareUrl.length) {
        axios
          .get(this.compareUrl, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
          .then((response) => {
            if (response && response.data) {
              this.compareSections = response.data.compareSections || {};
              this.metaData = response.data.metaData || {};
            }
          })
          .finally((this.loading = false));
      }
    },

    getData(key) {
      switch (key) {
        case 'overview':
          return this.compareSections.overview.compareItems;
        case 'techSpecs':
          return this.compareSections.techSpecs.specGroups;
        case 'why_we_love_it':
          return this.compareSections.techSpecs.specGroups;
        default:
          return [];
      }
    },

    whichSection(key) {
      switch (key) {
        case 'overview':
          return 'compareOverview';
        case 'techSpecs':
          return 'compareTechSpecs';
        case 'why_we_love_it':
          return 'compareWhyWeLoveIt';
        default:
          return null;
      }
    },

    ...mapActions('compare', ['emptyRack']),
  },
};
</script>

<style>
.compare-chart__cell .swatches {
  --color-selector-size-base: 1rem;
  margin: 0;
  justify-content: start;
}
</style>
